import React from "react";
import { Badge } from "@masterteam/mt-design-react";

import "./style.scss";

function PercentageBadge({ num = 0, error = false }) {
  return (
    <Badge variant={error ? "error" : "primary"} className="percentage-badge">
      {num}%
    </Badge>
  );
}

export default PercentageBadge;
